module.exports = __webpack_public_path__ + "static/media/beach2385.e07a19e8.jpg";